module.exports = __webpack_public_path__ + "static/floater-3ef163d46bed271881c451bfe2f3c8b4.jpg";